import React from "react";

import CounterCardSection from "./CounterCardSection";

import {fetchRaffle} from "../util";

import "./Counter.scss";

export default class Counter extends React.Component {
    constructor(props) {
        super(props);
    }

    padNumber(number) {
        return number < 10 ? `0${number}` : number;
    }

    render() {
        const {compact} = this.props;
        const {hours, minutes, seconds} = this.props.countdown;

        return (
            <div className="row">
                <div className="col-12">
                    <div className={`counter${compact ? " is-compact justify-content-lg-center" : " justify-content-center"} d-flex`}>
                        <CounterCardSection compact={compact} value={this.padNumber(hours)} type="hours" />

                        <CounterCardSection compact={compact} value={this.padNumber(minutes)} type="minutes" />

                        <CounterCardSection compact={compact} value={this.padNumber(seconds)} type="seconds" />
                    </div>
                </div>
            </div>
        );
    }
}
